import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form-blocker"
export default class extends Controller {
  static targets = ["form", "formContainer"]
   static classes = ["formLoading", "formContainerLoading"]


  loadStart() {
    this.formTarget.classList.add(...this.formLoadingClasses)
    this.formContainerTarget.classList.add(...this.formContainerLoadingClasses)
  }

  loadEnd() {
    this.formTarget.classList.remove(...this.formLoadingClasses)
    this.formContainerTarget.classList.remove(...this.formContainerLoadingClasses)
  }
}
